import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './errors';

/**
 * Global QueryClient singleton. Configure defaults to match the backend behavior:
 * - Don't retry on auth errors or 4xx — these won't succeed on retry
 * - Short staleTime by default; heavy screens override
 * - Disable refetch on window focus (not what PM users expect)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.isAuthError) return false;
          if (error.status >= 400 && error.status < 500) return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
